import { LocalStorageKeys } from '@containers/App';
import { Avatar, Select, Tooltip } from 'antd';
import React from 'react';

import I18n from '../i18n';
import styled, { Theme } from '../styled-components';

type PropType = {
    placeholder: string,
    title: string,
    required?: boolean,
    tooltip?: string,
    onChange: Function,
    validator: Function,
    initialValue: string[],
};

type StateType = {
    values: string[];
};

export default class SelectTagsComponent extends React.Component<PropType, StateType> {

    constructor(props: any) {
        super(props);

        this.state = {
            values: [],
        }

        this.validateField = this.validateField.bind(this);
        this.handleChange = this.handleChange.bind(this);
    }

    changeLocale(locale: any) {
        // moment.locale((locale == "pt-BR") ? "pt" : "en");
    }

    componentDidMount() {
        this.props.validator(this.validateField);
    }

    validateField = (rule: any, value: any, callback: Function) => {
        if (this.props.required) {
            if (this.state.values.length == 0) {
                callback(I18n.l('form.validation.tags.required'));
                return;
            }
        }
        callback();
    }

    handleChange(values: any) {
        this.setState({ values })
        this.props.onChange(values);
    }

    render() {
        const {
            placeholder,
            tooltip,
            initialValue
        } = this.props;

        const {
        } = this.state;
        this.changeLocale(localStorage.getItem(LocalStorageKeys.LOCALE));

        return (
            <Wrapper>
                <span className="field-title">
                    <span>{this.props.title} </span>

                    {!this.props.required && (
                        <span className="goepik-text-gray goepik-small-left-margin" style={{ fontWeight: 'normal' }}> ({I18n.l('common.optional')})</span>
                    )}
                    {(tooltip && tooltip) !== '' && (
                        <Tooltip overlayClassName={"custom-tooltip"} title={tooltip} placement="bottomLeft">
                            <Avatar className="goepik-small-left-margin tooltip-circle goepik-avatar" icon="question" />
                        </Tooltip>
                    )}
                </span>
                <Select
                    mode="tags"
                    placeholder={placeholder}
                    onChange={this.handleChange}
                    defaultValue={initialValue}
                    dropdownMatchSelectWidth={true}
                    notFoundContent={<span>{I18n.l('form.validation.tags.noValue')}</span>}
                >
                </Select>
            </Wrapper>
        );
    }
}


const Wrapper = styled.div`
    display: flex;
    flex: 1;
    flex-flow: column;
    overflow-x: auto;
    width: 100%;   

    .field-title{
        font-weight:bold;
        display: flex;
        align-items: center;
    }
    
    .ant-select-selection--multiple {
        height: 100px;
    }

    .tooltip-circle{
        background-color: ${Theme.primary.regular};
    }

    .ant-avatar.ant-avatar-icon{
        font-size: 13px
    }
    
    

    .goepik-avatar{
        width: 19px;
        height: 19px;
        display: flex;
        align-items: center;
        justify-content: center;
    }
`;
